import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';
import { Form } from 'antd';

const PearlsProvider = (props) => {
  const api = new API();
  const [formEditPearls] = Form.useForm();
  const [fetchPearlsList, setFetchPearlsList] = useState([]);
  const [corentPage, setCorentPage] = useState(1);
  const [tableFilter, setTableFilter] = useState({
    name: '',
    subcategory_id: null,
    subject_id: null,
    page: 1,
    limit: 20
  });
  const [loader,setLoader] = useState({
    table: false,
    subdropdown: false,
    subcatdropdown:false,
    add: false,
    edit: false,
    view: false,
    list: false,
    update: false,
    delete: false,
    relatedmcqs: false,
    subjectmcqs: false
  });
  const [viewScreenPearls, setViewScreenPearls] = useState({
    add:false,
    edit:false,
    view:false,
    list:true,
    editsnap:false,
    
  });
  const [subjectDropDown,setSubjectDropDown] = useState([]);
  const [subCategoryDropDown,setSubCategoryDropDown] = useState([]);
  const [pearlsList,setPearlsList] = useState([]);
  const [pearlsSingle,setPearlsSingle] = useState({});
  const [singlePearlsId,setSinglePearlsId] = useState("");
  const [relatedMcqs,setRelatedMcqs] = useState([]);
  const [relatedSubject,setRelatedSubject] = useState([]);
  const [selectSubject,setSelectSubject] = useState([]);
  const [addPearlsForm,setAddPearlsForm] = useState({
    question_name: "",
    question_description: "",
  })
  const [pearlsCatLoader, setPearlsCatLoader] = useState(false);
  const [pearlsCatList, setPearlsCatList] = useState([]);
  const [pearlsCatTableFilter, setPearlsCatTableFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [pearlsSubCatLoader, setPearlsSubCatLoader] = useState(false);
  const [pearlsSubCatList, setPearlsSubCatList] = useState([]);
  const [pearlsSubCatTableFilter, setPearlsSubCatTableFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });

  const [appSettings1,setAppSettings1] = useState({});
  const [appSettingsLoading1,setAppSettingsLoading1] = useState(false);
  const [appSettingsULoading1,setAppSettingsULoading1] = useState(false);
  const [updateName1,setUpdateName1] = useState("");
  const [pearlsTopicLoader, setPearlsTopicLoader] = useState(false);
  const [pearlsTopicList, setPearlsTopicList] = useState([]);
  const [bulkActionPearlsExam, setBulkActionPearlsExam] = useState([]);
  const [bulkActionPearlsExamLoader, setBulkActionPearlsExamLoader] = useState(false);
  const [bulkActionPearlsType, setBulkActionPearlsType] = useState(false);
  const fetchPearlsSubCatList = async (id) => {
    setPearlsSubCatLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("pearls/subcategorylist/list", { ...pearlsSubCatTableFilter, id: id }, (err, res) => {
        if (res?.data?.status === 200) {
          setPearlsSubCatList(res?.data?.data);
          setPearlsSubCatLoader(false);
        } else {
          setPearlsSubCatList([]);
          setPearlsSubCatLoader(false);
        }
      });
  }
  const fetchPearlsCatList = async () => {
    setPearlsCatLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("pearls/categorylist/list", { ...pearlsCatTableFilter }, (err, res) => {
        if (res?.data?.status === 200) {
          setPearlsCatList(res?.data?.data);
          setPearlsCatLoader(false);
        } else {
          setPearlsCatList([]);
          setPearlsCatLoader(false);
        }
      });
  }
  const getAppSettings1 = async () => {
    if (localStorage.getItem("rxdx_admin_login") === "true") {
      setAppSettingsLoading1(true);
      try {
        const res = await api.getAll("pearls/appsettings", {});
        if (res?.data?.status === 200) {
          setAppSettings1(res?.data?.data);
          setUpdateName1(res?.data?.data?.pearls_name);
        } else {
          setAppSettings1({});
        }
      } catch (err) {
        setAppSettings1({});
      } finally {
        setAppSettingsLoading1(false);
      }
    }
  }  
  const updateAppSettings1 = async (pearls_name) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
    setAppSettingsULoading1(false);
      (await api.create("pearls/appsettings", {
        pearls_name:pearls_name
      }, (err, res) => {
        if (res?.data?.status === 200) {
          getAppSettings1();
          setAppSettingsULoading1(false);
        } else {
          setAppSettingsULoading1(false);
        }
      }));
  }
  const fetchPearlsTable = async (scid,cid) => {
    setLoader({
      ...loader,
      table: true
    });
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pearls/subjectwise", { ...tableFilter,subcategory_id:scid,category_id:cid }, (err, res) => {
        if (res?.data?.status === 200) {
          setFetchPearlsList(res?.data?.data);
        } else {
          setFetchPearlsList([]);
        }
        setLoader({
          ...loader,
          table: false
        });
      }));
  };

  const loadSSubjectDropdown = async () => {
    setLoader({
      ...loader,
      subdropdown: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("subjectmaster/dropdown", {}, (err, res) => {
        if(res?.data?.status === 200) {
          setSubjectDropDown(res?.data?.data);
        } else {
          setSubjectDropDown([]);
        }
        setLoader({
          ...loader,
          subdropdown: false
        })
      }))
  }

  const loadSubCategoryDropdown = async () => {
    setLoader({
      ...loader,
      subcatdropdown: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("categorymaster/dropdownsub", {}, (err, res) => {
        if(res?.data?.status === 200) {
          setSubCategoryDropDown(res?.data?.data);
        } else {
          setSubCategoryDropDown([]);
        }
        setLoader({
          ...loader,
          subcatdropdown: false
        })
      }))
  }

  const addNewPearls = async (data,scid,sid,resetAdd,tid,callback) => {
    setLoader({
      ...loader,
      add: true
    })
    const formData = new FormData();
    formData.append("question_name", data?.question_name);
    formData.append("question_description", data?.question_description);
    formData.append("reference", data?.reference);
    formData.append("plan", data?.plan);
    formData.append("subject_id", sid);
    formData.append("topic_id", tid);
    formData.append("subcategory_id", scid);
    if (data.tag_question) {
      data.tag_question.forEach(function(tag) {
        formData.append("tag_question[]", tag);
      });
    }
    if (data.tag_subject) {
      data.tag_subject.forEach(function(tag) {
        formData.append("tag_subject[]", tag);
      });  
    }
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("pearls", formData, (err, res) => {
        if(res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          setAddPearlsForm({
            question_name: "",
            question_description: "",
          })
          resetAdd();
          // getPearlsAll(scid,sid,corentPage);
          callback && callback(err, res);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setLoader({
          ...loader,
          add: false
        })
      }))
  }

  const getPearlsAll = async (tid,page=1,limit=200,callback=null) => {
    setLoader({
      ...loader,
      list: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pearls/pearls_notes_list_v2", {topic_id: tid,page:page,limit:limit  }, (err, res) => {
        if(res?.data?.status === 200) {
          callback && callback(err, res);
          setPearlsList(res?.data?.data);
        } else {
          setPearlsList([]);
        }
        setLoader({
          ...loader,
          list: false
        })
      }))
  }

  const getSinglePearls = async (id) => {
    setViewScreenPearls({
      ...viewScreenPearls,
      list: false,
      add: false,
      view: true
    })
    setLoader({
      ...loader,
      view: true
    })
    formEditPearls.resetFields();
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getSingle("pearls/single", id, (err, res) => {
        if(res?.data?.status === 200) {
          fetchRelatedMcqs(res?.data?.data?.subject_id?._id);
          setPearlsSingle(res?.data?.data);
          setSinglePearlsId(res?.data?.data?._id);
          formEditPearls.setFieldsValue(res?.data?.data);
        } else {
          setPearlsSingle({});
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setLoader({
          ...loader,
          view: false
        })
      }))
  }

  const updatePearls = async (data, id, scid, sid, resetEdit,tid,callback=null) => {
    setLoader({
      ...loader,
      update: true
    })
    const formData = new FormData();
    formData.append("question_name", data?.question_name);
    formData.append("question_description", data?.question_description);
    formData.append("reference", data?.reference);
    formData.append("plan", data?.plan);
    formData.append("topic_id", tid);
    if (data.tag_question) {
      data.tag_question.forEach(function(tag) {
        formData.append("tag_question[]", tag);
      });
    }
    if (data.tag_subject) {
      data.tag_subject.forEach(function(tag) {
        formData.append("tag_subject[]", tag);
      });  
    }
    localStorage.getItem("rxdx_admin_login") === "true" &&
      // (await api.update("pearls", id, formData, (err, res) => {
        (await api.update("duplicate/pearlsupdate", id, formData, (err, res) => {
        if(res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          resetEdit();
          // getPearlsAll(scid, sid,corentPage);
          callback && callback(err, res);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setLoader({
          ...loader,
          update: false
        })
      }))
  }

  const deletePearls = async (id, scid, sid,callback=null) => {
    setLoader({
      ...loader,
      delete: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.remove("pearls", id, (err, res) => {
        if(res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          setViewScreenPearls({
            ...viewScreenPearls,  
            add: false,
            view: false,
            edit: false,
            update: false,
            list: true,
          })
          // getPearlsAll(scid, sid);
          callback && callback(err, res);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setLoader({
          ...loader,
          delete: false
        })
      }))
  }

  const scrollToTopViewPearls = (id) => {
    document.getElementById(`question_order_${id}`).scrollIntoView({ top: 0, behavior: 'smooth' });
  }

  const fetchRelatedSubject = async () => {
    setLoader({
      ...loader,
      subjectmcqs: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pearls/subjectlist",{}, (err, res) => {
        if(res?.data?.status === 200) {
          setRelatedSubject(res?.data?.data);
        } else {
          setRelatedSubject([]);
        }
        setLoader({
          ...loader,
          subjectmcqs: false
        })
      }))
  }
  function dangerouslySetInnerHTMLToText(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  }
  const fetchRelatedMcqs = async (e) => {
    setRelatedMcqs([]);
    setLoader({
      ...loader,
      relatedmcqs: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pearls/questiontag", {subject_id: e}, (err, res) => {
        if(res?.data?.status === 200) {
          setRelatedMcqs(
            (res?.data?.data ?? []).map((mcq) => ({
              value: mcq?.value,
              label: mcq.label ? (
                dangerouslySetInnerHTMLToText(mcq.label)
              ) : null
            }))
          );
          
        } else {
          setRelatedMcqs([]);
        }
        setLoader({
          ...loader,
          relatedmcqs: false
        })
      }))
  }
  const fetchTopicPearls = async (e) => {
    setPearlsTopicList([]);
    setPearlsTopicLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pearls/topiclist/list", {subject_id: e}, (err, res) => {
        if(res?.data?.status === 200) {
          setPearlsTopicList(res?.data?.data);
          
        } else {
          setPearlsTopicList([]);
        }
        setPearlsTopicLoader(false);
      }))
  }

  const bulkActionPearls = async (ids = [], action = null,scid=null, sid=null,callback=null) => {
    if (ids.length === 0) return;
    if (!action) return;
    setBulkActionPearlsExamLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.create("examsnew/bulk_action_pearls", {
        ids: ids,
        action: action
      }, (err, res) => {
        if (res?.data?.status === 200) {
          // scid && sid && getPearlsAll(scid, sid);
          callback && callback(err, res);
          setBulkActionPearlsExam([]);
          setBulkActionPearlsExamLoader(false);
        } else {
          setBulkActionPearlsExamLoader(false);
        }
      });
  }

  const statusUpdatePearls = async (status, id, callback = null) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update("pearls/statusupdate", id, { status }, (err, res) => {
        if(res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          callback && callback(err, res);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
      }))
  }

   return (
    <Context.Provider value={{
      ...props,
      fetchPearlsList,
      fetchPearlsTable,
      setFetchPearlsList,
      tableFilter,
      setTableFilter,
      loader,
      subjectDropDown,
      loadSSubjectDropdown,
      loadSubCategoryDropdown,
      subCategoryDropDown,
      addPearlsForm,
      setAddPearlsForm,
      addNewPearls,
      viewScreenPearls,
      setViewScreenPearls,
      getPearlsAll,
      setPearlsList,
      pearlsList,
      getSinglePearls,
      pearlsSingle,
      setPearlsSingle,
      formEditPearls,
      singlePearlsId,
      setSinglePearlsId,
      updatePearls,
      deletePearls,
      scrollToTopViewPearls,
      fetchRelatedMcqs,
      relatedMcqs,
      relatedSubject,
      setRelatedSubject,
      fetchRelatedSubject,
      selectSubject,
      setSelectSubject,
      setRelatedMcqs,
      appSettings1,setAppSettings1,
      appSettingsLoading1,setAppSettingsLoading1,
      appSettingsULoading1,setAppSettingsULoading1,
      updateAppSettings1,
      getAppSettings1,
      updateName1,setUpdateName1,
      fetchPearlsCatList,
      pearlsCatLoader, setPearlsCatLoader,
      pearlsCatList, setPearlsCatList,
      pearlsCatTableFilter, setPearlsCatTableFilter,
      fetchPearlsSubCatList,
      pearlsSubCatLoader, setPearlsSubCatLoader,
      pearlsSubCatList, setPearlsSubCatList,
      pearlsSubCatTableFilter, setPearlsSubCatTableFilter,
      fetchTopicPearls,
      pearlsTopicLoader, setPearlsTopicLoader,
      pearlsTopicList, setPearlsTopicList,
      corentPage, setCorentPage,
      bulkActionPearls,
        bulkActionPearlsExam, setBulkActionPearlsExam,
        bulkActionPearlsExamLoader, setBulkActionPearlsExamLoader,
        bulkActionPearlsType, setBulkActionPearlsType,
        statusUpdatePearls,
    }}>
      {props.children}
    </Context.Provider>
   ) 
};

export default PearlsProvider;